import React from "react";
import "./avisoComercial.css";

export default function AvisoComercial() {
  return (
    <div className="container py-4">
      <div className="secretaria_funciones">
        <h3 className="title">AVISO DE PRIVACIDAD INTEGRAL</h3>
        <hr className="hr-gob" />
      </div>
      <div>
        <p className="centrar-acomercial">
          <strong>
            Propósito por el cual se recaban sus datos personales y protección
            de los mismos
          </strong>
        </p>
        <p>
          <strong>La Dirección Comercial,</strong> perteneciente la Comisión de
          Agua y Alcantarillado de Sistemas Intermunicipales, ubicada en
          <strong>
            Av. Industrial La Paz No. 200 Col. Industrial la Paz, Pachuca,
            Hidalgo
          </strong>{" "}
          es la responsable del uso y protección de sus datos personales con
          fundamento en el Artículo 67 de la Ley de Transparencia y Acceso a la
          Información Pública para el Estado de Hidalgo así como a la Ley de
          Protección de Datos Personales en Posesión de Sujetos Obligados para
          el Estado de Hidalgo en sus artículos 1°, 3° fracciones I y XXX, 34,
          35 y 39 informándole lo siguiente:
        </p>
        <p>
          Los datos personales que recabamos y utilizamos de usted, son
          necesarios para el servicio y/o trámite que solicita, y los
          utilizaremos para las siguientes{" "}
          <strong>
            finalidades de conformidad al fundamento legal referido en cada una
            de ellas:
          </strong>
        </p>
        <ul>
          <li>
            Ejecutar la relación contractual existente con sus usuarios, que son
            necesarias para el servicio que solicita;
          </li>
          <li>Proveer los servicios requeridos;</li>
          <li>
            Permitir, al usuario, interactuar con la organización, así como que
            poder ser sujeto de derechos.
          </li>
        </ul>
        <p>
          <strong>Nota:</strong> Le informamos que, si usted no manifiesta su
          negativa para llevar a cabo el tratamiento descrito en los apartados
          anteriores, entenderemos que ha otorgado su consentimiento para
          hacerlo; salvo lo establecido por los Artículos 19 y 98 por causas de
          excepción previstas en la citada ley de protección de datos
          personales.
        </p>
        <p>
          Para llevar a cabo las finalidades descritas en el presente Aviso de
          Privacidad, utilizaremos los siguientes datos personales:{" "}
        </p>
        <ol>
          <li>Nombre Completo o Razón Social</li>
          <li>RFC y CURP</li>
          <li>Domicilio,</li>
          <li>Teléfono,</li>
          <li>Correo Electrónico particular,</li>
          <li>Firma Autógrafa,</li>
          <li>Área de Terreno M2.</li>
        </ol>
        <p>
          Además de los datos personales mencionados anteriormente, para las
          finalidades informadas, NO utilizaremos datos personales considerados
          como sensibles, que requieren de especial protección.
        </p>
        <p>
          COMISIÓN DE AGUA Y ALCANTARILLADO DE SISTEMAS INTERMUNICIPALES {"("}
          CAASIM {")"}. reconoce, respeta y garantiza la protección de sus datos
          personales. Le informamos que sus datos personales se utilizarán para
          proporcionarle alguno de los servicios que ofrece el Organismo. Si
          desea mayor información acerca del uso y tratamiento de sus datos
          personales y de los derechos que puede hacer valer, por favor consulte
          nuestro aviso de privacidad en:{" "}
          <a href="https://caasim.hidalgo.gob.mx/">
            https://caasim.hidalgo.gob.mx/
          </a>
        </p>
        <p>
          Cláusula de Transferencia. - Se informa que los datos personales No
          serán compartidos con dependencias distintas a la CAASIM y será
          tratada como Información Confidencial según el Artículo 114, así como
          el Artículo 118 de la Ley de Transparencia y Acceso a la Información
          Pública para el Estado de Hidalgo; para poder permitir el acceso a
          información confidencial y datos sensibles, se requerirá en todo
          momento el consentimiento expreso y por escrito de los particulares.
        </p>
        <p className="blue-text-acomercial">
          La última actualización y/o modificación del presente aviso es la indicada al final del mismo, situación que también podrá
informarse directamente en las oficinas de esta área responsable de la protección de sus datos.
        </p>
        <p>
          Usted tiene derecho a conocer qué datos personales tenemos de usted,
          para qué los utilizamos y las condiciones del uso que les damos
          <strong>
            {" "}
            {"("}acceso{")"}
          </strong>
          . Asimismo, es su derecho solicitar la corrección de su información
          personal en caso de que esté desactualizada, sea inexacta o incompleta{" "}
          <strong>
            {"("}rectificación{")"}
          </strong>
          ; que la eliminemos de nuestros registros o bases de datos cuando
          considere que la misma no está siendo utilizada conforme a los
          principios, deberes y obligaciones previstas en la normativa{" "}
          <strong>
            {"("}cancelación{")"}
          </strong>
          ; así como oponerse al uso de sus datos personales para fines
          específicos{" "}
          <strong>
            {"("}oposición{")"}
          </strong>
          . Estos derechos se conocen como derechos <strong>ARCO</strong>.
        </p>
        <p>
          Los datos de contacto de la Unidad de Transparencia del Poder
          Ejecutivo, quién gestionará las solicitudes para el ejercicio de
          derechos ARCO, asimismo auxiliará y orientará respecto al ejercicio
          del derecho a la protección de datos personales, son los siguientes:
          Carretera a la Estanzuela S/N San Agustín Tlaxiaca, Hgo. C.P. 42162
          E-mail: <a href="mailto:uipg@hidalgo.gob.mx">uipg@hidalgo.gob.mx</a>
        </p>
        <p className="text-align-right-acomercial">
          <strong>Fecha de actualización <span className="blue-text-acomercial">23/06/2025</span></strong>
        </p>
      </div>
    </div>
  );
}
